/**
 * =============================================================================
 * legacy-bundles.js 
 * =============================================================================
 * Migrated from old theme. Spaghetti.
 * =============================================================================
 */

var LegacyBundles = {

  init: function() {
    document.addEventListener('minicart:rendered', this.handleMinicartUpdated.bind(this));
  },

  onReady: function() {
    // Triggers a cart fetch, triggering an updated minicart, thus causing this script to be run.
    // setTimeout(function(){ $.get({ url: "/cart.js", dataType: 'json' }); }, 500); // Trigger an update
    let cartJSON = JSON.parse(document.querySelector("#minicart-json").innerText);
    let itemsInOffer = this.findOffers(cartJSON.items);
    //console.log("[LB] onReady itemsinoffer", itemsInOffer);

    this.showBundleDetailsInMinicart(itemsInOffer);
  },

  handleMinicartUpdated: function(e) {
    let cartItems = e.detail.cart?.items;
    //console.log('[L-B] Cart items', cartItems);
    if(cartItems === undefined) {
      return;
    }
    let itemsInOffer = this.findOffers(cartItems);
    //console.log("[LB] itemsinoffer", itemsInOffer);

    this.showBundleDetailsInMinicart(itemsInOffer);
  },

  // No idea how this works. Step 1A in bundle process. See shop.js L1699
  findOffers: function(items){
    var that = this;
    var offerStorage = {};
    var itemsInOffer = []; 

    // build the offerStorage object splitting offer items by handle //
    items.forEach(function (item, i) {
      if (!item.properties) return;
      if (!item.properties._bogofType) return;
      item.properties._bogofName.trim();

      if (!offerStorage[item.properties._bogofName]) offerStorage[item.properties._bogofName] = [];
      offerStorage[item.properties._bogofName].push(item);
    });

    Object.keys(offerStorage).forEach(function (offerItemHandle) {
      var itemInOffer = that.applyOffer(offerStorage[offerItemHandle]);
      itemsInOffer[itemsInOffer.length] = itemInOffer;
    });

    return itemsInOffer;
  },

  // No idea how this works. Step 1B in bundle process. See shop.js L1699
  applyOffer: function (offerItems) {
    var that = this;
    function formatOfferType(type) {
      if (type === 'bundle') return 'bogOff';
      if (type === 'discountedVendor') return 'vendor';
      if (type === 'discountedType') return 'type';
      if (type === 'tagDiscount') return 'tag';
    }

    var itemInOffer = {
      items: offerItems.map(function (item, i) {
        return {
          handle: item.handle,
          prop: item.properties,
          size: item.variant_options[0],
          url: item.url,
          amount: item.quantity,
          image: item.image,
          title: item.title,
          price: item.discounted_price,
          original_price: item.price,
          product_id: item.product_id,
          variant_id: item.variant_id,
          key: item.key
        };
      }),
      bundleHandler: offerItems[0].variant_id,
      quantity: offerItems.reduce(function (totalQuantity, currentItem) {
        return totalQuantity += (+currentItem.quantity);
      }, 0),
      typeOfOffer: formatOfferType(offerItems[0].properties._bogofType),
      offerBanner: offerItems[0].properties._offerBanner
    };


    if (itemInOffer.typeOfOffer === 'bogOff') {
      var neededQuantity = +offerItems[0].properties._bogofQuantity;
      var amountChanged = +offerItems[0].properties._bogofAmountChanged;

      itemInOffer.loop = Math.floor(itemInOffer.quantity / neededQuantity);
      itemInOffer.discountedPerLoop = amountChanged;
      itemInOffer.totalPerLoop = neededQuantity;
      itemInOffer.overflow = itemInOffer.quantity % neededQuantity;
      itemInOffer.moreNeeded = itemInOffer.overflow > 0 ? neededQuantity - itemInOffer.overflow : 0;
      itemInOffer.bundles = that.getBundles(itemInOffer);
      itemInOffer.offerTitle = offerItems[0].properties._offerTitle;
      itemInOffer.offerDescription = offerItems[0].properties._offereDescription;
    }else{
      itemInOffer.offerTitle = offerItems[0].properties._offerTitle;
      itemInOffer.offerDescription = offerItems[0].properties._offereDescription;
    }

    return itemInOffer;
  },

  // No idea how this works. Step 1C in bundle process. See shop.js L1699
  getBundles: function (itemInOffer) {
    var bundleIndex = 0;
    var bundleArray = [[]];

    itemInOffer.items.forEach(function (item) {
      //if (bundleArray[bundleIndex].length === itemInOffer.totalPerLoop) bundleIndex += 1;
      if (!bundleArray[bundleIndex]) bundleArray[bundleIndex] = [];

      return bundleArray[bundleIndex].push(item);
    });

    return bundleArray;
  },

  // No idea how this works, but trying to make sense of it. Step 2A in bundle
  // process
  showBundleDetailsInMinicart: function(itemsInOffer){
    var that = this;
    itemsInOffer.forEach(function (itemInOffer) {
      // if this is a bundle we need to output this instead
      if (itemInOffer.bundles) {
        itemInOffer.bundles.forEach(function (bundle) { 
          bundle.forEach(function (item, i) {
            // Shopify scripts can switch around which items are in the BOGOF as long as the value is correct, so need to adjust the minicart each time
            var html = that.generateLineItemOfferHtml(item, itemInOffer, item.amount,itemInOffer); // TODO BY PH
            var priceAttr = item.price * item.amount; //slate.Currency.formatMoney(item.price * item.amount, theme.moneyFormat);
            var selector = '[data-tile-line-item="'+(item.key)+'"]';
            //console.log('[L-B] item', item);
            //console.log("[L-B] selector", selector);
            var parentLineItemObjs = document.querySelectorAll('[data-tile-line-item="'+(item.key)+'"]');
            // var parentLineItemObj = $('[data-mp-minicart-item="'+(item.variant_id)+'"][data-mp-minicart-price="'+priceAttr+'"]');
            // console.log('[L-B] parentselector', '[data-mp-minicart-item="'+(item.variant_id)+'"][data-mp-minicart-price="'+priceAttr+'"]');
            // console.log("[L-B] html", html);
            //console.log("[L-B] parent", parentLineItemObj);
            //console.log('[L-B] HTML', html);
            // TODO! Below 3
            parentLineItemObjs.forEach(e => {
              if(html != ""){
                e.insertAdjacentHTML("beforeend", "<div class='col-12'><div class='fs-8 fw-bold alert alert-primary p-2 m-0'><div class='minicart-bundle-message'>"+html+"</div></div></div>");
              }
            });
            //var lineItemInfoBoxObj = $('[data-mp-minicart-item-info]', parentLineItemObj);
            //lineItemInfoBoxObj.append(html);
          });
        });
        return;
      }
      itemInOffer.items.forEach(itemHtml);
    });
  },

  // No idea how this works, but trying to make sense of it. Step 2B in bundle
  // process
  generateLineItemOfferHtml: function(item, itemOffer, bundleQuantity, bundleOffer){
    var offerType = "";
    if(bundleOffer != undefined){
      if(bundleOffer.offerBanner != undefined){
        offerType = bundleOffer.offerBanner.trim();
      }
      else{
        offerType = '';
      }
    }

    var html = "";

    var moreNeeded = +itemOffer.moreNeeded;
    var flashTag = ''
    if (item.prop._offerType) {
      flashTag = item.prop._offerType.split(' ').join('-');
    }
    var tagsAsString = Object.keys(item.prop).reduce(function (tagString, tag) {
      if (~tag.indexOf('flash')) flashTag = tag.trim().replace(/ /g, '-').replace('flash-', '');
      return tagString += ',' + tag + ':' + item.prop[tag];
    }, '');


    if (typeof bundleQuantity === 'object') bundleQuantity = item.amount;

    if (item.price < item.original_price) {
      html += '<span class="discount-text">DISCOUNT PRODUCT! ' + (100 - (item.price/item.original_price*100)).toFixed(0) + '% OFF!</span>';
    } else if (moreNeeded !== "undefined" && moreNeeded !== 0 && !isNaN(moreNeeded)) {
      html += '' +
          '<span class="dontMiss"><span style="font-weight:bold" color="#000">Don\'t Miss Out!</span> - Add ' + moreNeeded + ' more to get the discount! - <a href="/collections/' + offerType.replace(/\s+/g, '-').replace(/%/g, '').toLowerCase() + '">View Offer</a></span><br>';
    }

    return html;
  }
};

export default LegacyBundles;